import React, { Component,useEffect,useState } from "react";
import 'react-widgets/dist/css/react-widgets.css';
import Multiselect from 'react-widgets/lib/Multiselect'
import DropdownList from 'react-widgets/lib/DropdownList'
import { Field } from "redux-form";
import Select from "react-select";
import appConfig from '../../config/config';
import axios from "axios";

const divStyleSection = {
    backgroundColor: '#fff'
};
const pcrData = [
    'PCR Exterior Residential  ',
    'PCR Interior  Residential',
    'PCR Interior  Commercial ',
    'PCR Exterior  Commercial  '];
const q = [
    "Current owner                ",
    "Two Owner                    ",
    "Full Customary search        ",
    "Title Update/Bringdown       ",
    "Deed Search                  ",
    "Tax Search                   ",
    "Judgment and Lien Search     ",
    "Electronic Recordation       ",
    "Non Electronic Recordation   "];

    const a = [
    "Vero Value ",
    "SafeValue  ",
    "Sitex      ",
    "RVM        ",
    "Valuesure  ",
    "Valuepoint ",
    "PASS       ",
    "CA Value MC",
    "CA Value   ",
    "HVE        ",
    "Ival Plus  ",
    "cascade    "
];

const userOptions = [
    { label:"Vero Value ", value :"Vero Value "}
]


const colors = [{ color: 'Red', value: 'ff0000' },
{ color: 'Green', value: '00ff00' },
{ color: 'Blue', value: '0000ff' }]
const p = ["2055 Exterior w/interior photos                                  ",
    "Single-family Appraisal (1004)                                   ",
    "Single-family Investment (1004 and 1007)                         ",
    "Single-family Investment (1004 and 216)                          ",
    "Single-family Investment (1004, 1007, and 216)                   ",
    "Single-family REO (1004 w/REO Addendum)                          ",
    "Single-family REO Exterior (2055 w/REO Addendum)                 ",
    "Exterior-only Single-family Appraisal (2055)                     ",
    "Exterior-only Single-family Investment (2055 and 1007)           ",
    "Exterior-only Single-family Investment (2055, 1007, and 216)     ",
    "Exterior-only Single-family w/Comparable Photos (2055)           ",
    "Condo Appraisal (1073)                                           ",
    "Condo Exterior-only Appraisal (1075)                             ",
    "Condo Exterior-only Investment (1075 and 1007)                   ",
    "Condo Exterior-only Investment (1075, 1007, and 216)             ",
    "Condo Investment (1073 and 1007)                                 ",
    "Condo Investment (1073 and 216)                                  ",
    "Condo Investment (1073, 1007, and 216)                           ",
    "Condo REO Appraisal (1073)                                       ",
    "Appraisal Update/Inspection of Repairs (1004D)                   ",
    "Appraisal Update/Recertification (1004D)                         ",
    "Manufactured Home (1004C)                                        ",
    "Manufactured Home Investment (1004C and 1007)                    ",
    "Manufactured Home Investment (1004C, 1007, and 216)              ",
    "Multi-family Appraisal (1025)                                    ",
    "Multi-family Investment (1025 and 216)                           ",
    "Multi-family REO Appraisal (1025)                                ",
    "Exterior-only Co-op Appraisal (2095)                             ",
    "Conversion - Conventional to FHA                                 ",
    "Conversion - FHA to Conventional                                 ",
    "Conversion - USDA to Conventional                                ",
    "Conversion - USDA to FHA                                         ",
    "JUMBO Single-family (1004)                                       ",
    "JUMBO Single-family Investment (1004 and 1007)                   ",
    "JUMBO Single-family Investment (1004 and 216)                    ",
    "JUMBO Single-family Investment (1004, 1007, and 216)             ",
    "JUMBO Condo (1073)                                               ",
    "JUMBO Multi-family (1025)                                        ",
    "JUMBO Multi-family Investment (1025 and 216)                     ",
    "JUMBO Investment Form (1007)                                     ",
    "JUMBO Investment Form (216)                                      ",
    "JUMBO Investment Forms Only (1007 and 216)                       ",
    "JUMBO Field Review                                               ",
    "JUMBO Desk Review                                                ",
    "JUMBO Enhanced Desk Review                                       ",
    "JUMBO Disaster Inspection Report                                 ",
    "JUMBO Appraisal Update/Final Inspection (1004D)                  ",
    "JUMBO Appraisal Update/Recertification of Value (1004D)          ",
    "Field Review (2000)                                              ",
    "Multi-family Field Review (FNMA 2000A)                           ",
    "FHA Reverse mortgage appraisal (1004)                            ",
    "FHA Single-family appraisal (FNMA 1004)                          ",
    "FHA Single-family Investment (1004 and 216)                      ",
    "FHA Single-family investment (1004 and 1007)                     ",
    "FHA Single-family investment (1004, 1007, and 216)               ",
    "FHA Single-family REO (1004 w/REO addendum)                      ",
    "FHA Appraisal Update/Inspection of Repairs (1004D)               ",
    "FHA Appraisal Update/Recertification of Value (1004D)            ",
    "FHA Condo (1073)                                                 ",
    "FHA Condo investment (1073 and 1007)                             ",
    "FHA Condo investment (1073, 1007, and 216)                       ",
    "FHA Exterior-only residential report (2055)                      ",
    "FHA Exterior-only Condo (1075)                                   ",
    "FHA Multi-family (1025)                                          ",
    "FHA Multi-family Investment (1025 and 216)                       ",
    "FHA Manufactured Home (1004C)                                    ",
    "FHA Manufactured Home Final Inspection (1004D)                   ",
    "FHA Manufactured Home Recertification of Value (1004D)           ",
    "FHA Field Review (HUD 1038)                                      ",
    "FHA Field Review (FNMA 2000)                                     ",
    "FHA Desktop Review                                               ",
    "FHA Desktop Review (Enhanced)                                    ",
    "FHA Disaster Inspection Report                                   ",
    "FHA Compliance Inspection (CIR)                                  ",
    "FHA Comparable Rent Schedule (1007)                              ",
    "FHA Operating Income Statement (216)                             ",
    "FHA Investment Forms Only (1007 and 216)                         ",
    "FHA 203K Single-family (1004)                                    ",
    "FHA 203K Multi-family (1025)                                     ",
    "FHA 203K Multi-family Investment (1025 and 216)                  ",
    "FHA 203K Field Review                                            ",
    "FHA 203K Desk Review                                             ",
    "FHA 203K Enhanced Desk Review                                    ",
    "FHA 203K Disaster Inspection Report                              ",
    "FHA 203K Appraisal Update/Final Inspection (1004D)               ",
    "FHA 203K Appraisal Update/Recertification of Value (1004D)       ",
    "USDA Single-family (1004)                                        ",
    "USDA Single-family Investment (1004 and 1007)                    ",
    "USDA Single-family Investment (1004 and 216)                     ",
    "USDA Single-family Investment (1004, 1007, and 216)              ",
    "USDA Manufactured Home (1004C)                                   ",
    "USDA Multi-family Investment (1025 and 216)                      ",
    "USDA Appraisal Update/Inspection of Repairs (1004D)              ",
    "USDA Appraisal Update/Recertification of Value (1004D)           ",
    "USDA Condo (FNMA 1073)                                           ",
    "USDA Disaster Inspection Report                                  ",
    "USDA Existing Dwelling Certification                             ",
    "USDA Enhanced Desk Review                                        ",
    "USDA Field Review (2000)                                         ",
    "Collateral Desktop Analysis                                      ",
    "Comparable Rent Schedule (1007)                                  ",
    "Standalone Investment Forms (1007 and 216)                       ",
    "Condition and Marketability Report (FHLMC 2070)                  ",
    "Co-op Appraisal (FNMA 2090)                                      ",
    "Desktop Appraisal (No Inspection)                                ",
    "Desktop Appraisal (Exterior)                                     ",
    "Desktop Appraisal (Interior)                                     ",
    "Desktop Review                                                   ",
    "Desktop Review (Enhanced)                                        ",
    "Disaster Inspection                                              ",
    "Drive by Appraisal (Legacy 2055)                                 ",
    "General Purpose Appraisal Report (GPAR)                          ",
    "Land Appraisal                                                   ",
    "Land Appraisal - REO                                             ",
    "Operating Income Statement (216)                                 ",
    "Property Inspection (FNMA 2075)                                  ",
    "Real Estate Value Estimate (RVE)                                 ",
    "Residential Appraisal Form - 71B                                 ",
    "Retrospective Field Review                                       ",
    "Supplemental REO Addendum                                        "];

const b = ["BPO - Interior                        ",
    "BPO - Exterior                        ",
    "FLOOD - Life of Loan w 30 yr tracking ",
    "FLOOD - Flood Zone Determination      "];
const e = [
    "Residential Ex",
    "Residential Interior",
    "Commercial Ex ",
    "Commercial int "
];
const empty = [];



const divStyleProduct = {
    paddingLeft: '0px'
};

class ProductCheck extends Component {
    render() {
        return (
            <div className="form-check">
                <Field name={this.props.data} component="input" type="checkbox" className="form-check-input" id={this.props.data} key={this.props.data} />
                <label className="form-check-label">{this.props.Name}</label>
            </div>
        );
    };
};
const ReduxFormSelect = props => {
    const { input, options } = props;
    return (
      <Select
        {...input}
        isClearable={true}
        onChange={value => input.onChange(value)}
        onBlur={() => input.onBlur(input.value)}
        options={options}
      />
    )
  }

const renderMultiselect = ({ input, data, disabled, valueField, textField }) =>
    <DropdownList {...input}
        onBlur={() => input.onBlur()}
        value={input.value || []} // requires value to be an array
        data={data}
        valueField={valueField}
        textField={textField}
        disabled={disabled}
    />
const ProductList = (props) => {
  //get productlist from api
  const [isLoading, Loaded] = useState(true);
  const [avm, setavm] = useState([]);
  const [app,setapp] = useState([]);
  const [title,settitle] = useState([]);
  const [pcr,setpcr] = useState([]);
  useEffect(() => {

    //download products
        axios.post(
            appConfig.apiGateway.searchUrl,
            JSON.stringify({ User: props.Role.email, Action: "PRODUCT" }),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => {
            var avm = JSON.parse(response.data.body).filter(p=>p.GROUP == 'AVM').map(q=>{
                return q.PRODUCT
            })
            setavm(avm)
            var app = JSON.parse(response.data.body).filter(p=>p.GROUP == 'APP').map(q=>{ return q.PRODUCT })
            setapp(app)

            var title = JSON.parse(response.data.body).filter(p=>p.GROUP == 'TITLE').map(q=>{ return q.PRODUCT })
            settitle(title)

            var pcr = JSON.parse(response.data.body).filter(p=>p.GROUP == 'PCR').map(q=>{ return q.PRODUCT })
            setpcr(pcr)

            console.log(avm)
            Loaded(true);
        }, error => {
        });

  },[]);
    return (
      <>
        {!isLoading && <span>Loading</span>}
        {isLoading && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-4 pl-0" style={{ backgroundColor: "#fff" }}>
                <div>
                  <label>AVM Product</label>
                  <Field
                    name="AVM"
                    component={renderMultiselect}
                    defaultValue={[]}
                    data={avm}
                  />
                </div>
              </div>

              <div className="col-4" style={{ backgroundColor: "#fff" }}>
                <div>
                  <label>Title Product</label>
                  <Field
                    name="Title"
                    component={renderMultiselect}
                    defaultValue={[]}
                    // disabled={!props.Role.role.includes('Admin')}
                    data={title}
                  />
                </div>
              </div>

              <div className="col-4" style={{ backgroundColor: "#fff" }}>
                <div>
                  <label>Appraisal Product</label>
                  <Field
                    name="Appraisal"
                    component={renderMultiselect}
                    defaultValue={[]}
                    // disabled={!props.Role.role.includes("Admin")}
                    data={app}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-4 pl-0" style={{ backgroundColor: "#fff" }}>
                <div>
                  <label>
                    Property Condition Report / BPO - Broker Price Opinion
                  </label>
                  <Field
                    name="PCR"
                    component={renderMultiselect}
                    defaultValue={[]}
                    // disabled={!props.Role.role.includes('Admin')}
                    data={pcr}
                  />
                </div>
              </div>

              {/* <div className="col-4" style={{ backgroundColor: "#fff" }}>
                <div>
                  <label>Flood</label>
                  <Field
                    name="BPO"
                    component={renderMultiselect}
                    defaultValue={[]}
                    disabled={!props.Role.role.includes("Admin")}
                    data={empty}
                  />
                </div>
              </div> */}

              {/* <div className="col-4" style={{ backgroundColor: "#fff" }}>
                <div>
                  <label>Evaluation</label>
                  <Field
                    name="EVAL"
                    component={renderMultiselect}
                    defaultValue={[]}
                    disabled={!props.Role.role.includes("Admin")}
                    data={empty}
                  />
                </div>
              </div> */}
            </div>
          </div>
        )}
      </>
    );
};

export default ProductList;